module.exports = __webpack_public_path__ + "static/media/hot.a68e456a.png";